export default __webpack_public_path__ + "img/97507a335fdd0bd69a5377f34be860ed.svg";